import { observable, action, runInAction, computed, makeObservable } from "mobx";
import { API } from "General/API";
import { handleStoreState, CoreStore } from "./RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import logoDefaultImage from "assets/img/pave-logo.svg";
import { fileToBase64 } from "utils/fileToBase64";

class HeaderStore extends CoreStore {
  logo: string | null = null;
  isDefaultLogo: boolean = true;
  originalImage: string | null = null;
  searchBar: boolean = false;

  constructor() {
    super();

    makeObservable(this, {
      logo: observable,
      isDefaultLogo: observable,
      originalImage: observable,
      searchBar: observable,
      logoVisible: computed,
      resetLogo: action.bound,
      setLogo: action.bound,
      getOriginalLogo: action.bound,
    });

    this.logo = null;
    this.isDefaultLogo = true;
  }

  clear() {
    this.resetLogo();
  }

  url(id: number): string {
    return API_URL.PROJECTS.getProjectLogo(id);
  }

  // TODO: Improve this method
  @handleStoreState()
  async setLogo(id: number, isOriginal = false) {
    let logoImageData;
    try {
      const logo = await API.request(this.url(id), { method: "GET", responseType: "blob" }, true);
      const logoObjectUrl = URL.createObjectURL(logo);
      logoImageData = logoObjectUrl;
      this.isDefaultLogo = false;

      if (isOriginal) {
        this.getOriginalLogo();
      }
    } catch (err) {
      logoImageData = logoDefaultImage;
    }
    runInAction(() => {
      this.logo = logoImageData;
    });
  }

  @handleStoreState()
  async getOriginalLogo() {
    const params = { original: true };
    let originalLogo;
    try {
      const originalImage = await API.request(
        this.url(projectsDataStore.projectId),
        { params: params, method: "GET", responseType: "blob" },
        true
      );
      originalLogo = await fileToBase64(originalImage);
      // const originalImageObjectUrl = window.URL.createObjectURL(originalImage);
      // originalLogo = originalImageObjectUrl;
    } catch (err) {
      originalLogo = null;
      throw err;
    }
    runInAction(() => {
      this.originalImage = originalLogo;
    });
  }

  @handleStoreState()
  resetLogo() {
    this.logo = null;
    this.originalImage = null;
    this.isDefaultLogo = true;
  }

  get logoVisible(): boolean {
    return window.location.pathname.indexOf("/project") !== -1;
  }
}

const headerStore = new HeaderStore();

export { headerStore };
